import React from 'react';

import Breadcrumb, { BreadcrumbItem } from 'view/section/Breadcrumb/Breadcrumb';
import { H2, H3 } from 'view/component/Tipografia/Texto';
import { Conteudo } from 'view/section/Conteudo/Conteudo';


const SobrePage: React.FunctionComponent = () => {
  return (
    <>
      <Breadcrumb>
        <BreadcrumbItem href="/">Início</BreadcrumbItem>
        <BreadcrumbItem>Sobre</BreadcrumbItem>
      </Breadcrumb>

      <Conteudo>
        <H2>Sobre este site</H2>

        {/* <p>Ícone: https://www.flaticon.com/free-icon/online-appointment_3063022, https://www.flaticon.com/free-icon/paper_3238024</p> */}
        <H3>Acordo de nível de serviço (SLA)</H3>
        <p>Em construção</p>

        <H3>Termos de uso</H3>
        <p>Em construção</p>

        <H3>Coleta dos dados</H3>
        {/* <p>Caso você queira acesso aos dados armazenados, abra uma solicitação de serviço</p> */}

        <p>
          Os dados coletados neste sistema poderão ser utilizados em outros sistemas institucionais
          para fins acadêmicos e institucionais, garantindo devidamente a segurança e o anonimato das informações,
          exceto para os casos de melhoria dos serviços prestados pela instituição, atividade fim deste sistema.
        </p>

        <p>Dentre os dados possivelmente coletados estão:</p>
        <ul>
          <li>
            <strong>Dados pessoais:</strong>
            <ul>
              <li><strong>Telefone:</strong> Telefone (Ramal) para contato alternativo ao cadastrado nos sistemas SI3. Poderá ser utilizado para contatos com alta prioridade; </li>
              <li><strong>E-mail:</strong> E-mail preferencial no qual o sistema informará as atualizações sobre as solicitações de serviço nas quais o usuário está relacionado.</li>
            </ul>
          </li>
          <li>
            <strong>Solicitações de serviço:</strong> Quaisquer informações referentes a atividade fim deste sistema.
          </li>
        </ul>

        <p>
          Além destes, informações referentes a utilização poderão ser coletados para fins de auditoria, tais como: ip de acesso, tamanho da tela,
          tempo de sessão, versão do navegador, rotas de acesso.
        </p>
        <p>
          Processos de auditoria incluem verificações automáticas e manuais de desempenho do sistema, 
          detecção de bugs e análises de comportamentos indevidos do sistema.
        </p>
      </Conteudo>
    </>
  )
}

export default SobrePage;
